/**
 * Created by meirr on 1/22/17.
 */
define(function (require) {

    var _ = require('underscore');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var FilterDropdownSelectionViewController = require('web-agent-components/FilterDropdownSelectionViewController');
    var FilterButtonSelectViewController = require('web-agent-components/FilterButtonSelectViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var APPLICATION_TYPE = 'MessagingAgentListTableViewController';

    var MessagingAgentListTableViewController = BaseTableViewController.extend({
        ControllerName: "MessagingAgentListTableViewController",
        applicationType: "MessagingAgentListTableViewController",
        LPClassesMap: {
            messagingAgentListTable: "messaging_agent_list_table"
        },
        LPPrefixMap: {
            messagingAgentList: "MESSAGING_AGENT_LIST"
        },
        translationTexts: {
            unassigned: "unassigned",
            NOT_AVAILABLE: "notAvailable"
        },

        initialize: function () {
            this.agentStatusReasons = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentReasonsCollection);
        },

        render: function () {
            this.addClass(this.view, this.LPClassesMap.messagingAgentListTable);
        }
    });

    MessagingAgentListTableViewController.prototype.getModelControllerInstance = function () {
        return lpTag.WebAgent.messagingAgentListController;
    };

    MessagingAgentListTableViewController.prototype.getConfiguration = function () {

        var modelController = this.getModelControllerInstance();
        var hasAgentManagerPrivilege = privilegesController.hasAgentManagerModulePrivilege();

        var configuration = {
            updateQueryCallback: modelController.updateQuery,
            context: this,
            textsPrefix: this.LPPrefixMap.messagingAgentList,
            tableName: this.applicationType,
            tableRootModelPath: "messagingAgentList",
            globalData: {
                modelController: modelController,
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.messagingAgentList
            },
            tableHead: {
                columnsData: [
                    {
                        iconType: "agents_header_status",
                        tooltip: this.LPPrefixMap.messagingAgentList +  "_table_column_status_tooltip",
                        tooltipAlign: "left",
                        sortTag: "status",
                        filter: {
                            filterManager: FilterButtonSelectViewController,
                            filterManagerData: {
                                multiple: true,
                                filterName: "agentStatus",
                                filterTextSuffix: "agentStatus",
                                buttons: [
                                    {
                                        status      : lpTag.WebAgent.logicController.AVAILABILITY_TYPES.AWAY,
                                        buttonId    : "away",
                                        iconClass   : "agent_status",
                                        iconType    : "AWAY",
                                        buttonText  : "{{filter_away_agentStatus}}"
                                    },{
                                        status      : lpTag.WebAgent.logicController.AVAILABILITY_TYPES.BACK_SOON,
                                        buttonId    : "back_soon",
                                        iconClass   : "agent_status",
                                        iconType    : "BACK_SOON",
                                        buttonText  : "{{filter_back_soon_agentStatus}}"
                                    },{
                                        status      : lpTag.WebAgent.logicController.AVAILABILITY_TYPES.ONLINE,
                                        buttonId    : "online",
                                        iconClass   : "agent_status",
                                        iconType    : "ONLINE",
                                        buttonText  : "{{filter_online_agentStatus}}"
                                    }
                                ]
                            }
                        }
                    },
                     {
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_stateDuration",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_stateDuration_tooltip"
                    },{
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_onlineRate",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_onlineRate_tooltip"
                    },{
                        agentImage: "agentImage"
                    },{
                        title : this.LPPrefixMap.messagingAgentList + "_table_column_agentName",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_agentName_tooltip",
                        sortTag: "agentName",
                        filter: {
                            filterManager: FilterDropdownSelectionViewController,
                            filterManagerData: {
                                className: "filter_dropdown_selection_view",
                                filterName: "agentIds",
                                filterTextSuffix: "agents",
                                filterDataModelPath:  "operators.array",
                                textProperty: "displayName",
                                toggleButton: agentLEManager.getLEConfig().supportDeletedUsers && {
                                    toggleByField: {
                                        fieldName: 'deleted'
                                    }
                                },
                                label: false
                            }
                        }
                    },{
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_agent_group",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_agent_group_tooltip",
                        //sortTag: "agentGroupName",
                        filter: {
                            filterManager: FilterDropdownSelectionViewController,
                            filterManagerData: {
                                className: "filter_dropdown_selection_view",
                                filterName: "agentGroupIds",
                                filterTextSuffix: "agentGroups",
                                filterDataModelPath: "agent.agentGroups.array",
                                textProperty: "displayName"
                            }
                        }
                    },
                    {
                        title : this.LPPrefixMap.messagingAgentList + "_table_column_skills",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_skills_tooltip",
                        filter: {
                            filterManager: FilterDropdownSelectionViewController,
                            filterManagerData: {
                                className: "filter_skills_dropdown_view filter_dropdown_selection_view",
                                filterName: "skillIds",
                                filterTextSuffix: "skills",
                                filterDataModelPath: "skills.array",
                                textProperty: "name"
                            }
                        }
                    },
                    {
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_concurrent",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_concurrent_tooltip",
                        sortTag: "openConversations"
                    }, {
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_active",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_active_tooltip"
                    }, {
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_maxConcurrent",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_maxConcurrent_tooltip",
                        sortTag: "configuredMaxSlots"
                    }, {
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_load",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_load_tooltip",
                        tooltipMoreInfoCallback: function() {
                            LE.vent.trigger("openKP", {fragment: "messaging-agent-list"});
                        },
                        sortTag: "load"
                    },{
                        title: this.LPPrefixMap.messagingAgentList + "_table_column_closedConversations",
                        tooltip: this.LPPrefixMap.messagingAgentList + "_table_column_closedConversations_tooltip"
                    }
                ]
            },
            tableBody: {
                htmlTable: true,
                ignoreRowHover: true,
                ignoreSectionHover: true,
                rowTemplateFile: 'LP_messaging_agent_list_table_row.html',
                dataRenderer: this.dataRenderer,
                dataBinder: this.dataBinder,
                supportKeysNavigation: true,
                disableLineClick: true
            },
            paging: {
                pageSize: this.getModelControllerInstance().getDefaultValue("limit"),
                hidePagingText: false
            }
        };
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        return configuration;
    };

    MessagingAgentListTableViewController.prototype.dataRenderer = {
        numberOfSections: function(data) {
            return 1;
        },
        numberOfRowsInSection: function(data, sectionIndex) {
            return data.length;
        },
        dataForSection: function(data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function(data, rowIndex, sectionIndex) {
            var agentInfo = data[rowIndex];
            var value = {};
            var naMessage = this.translate(this.translationTexts.NOT_AVAILABLE);
            if (agentInfo) {
                value.id = agentInfo.agentId;
                value.darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';
                value.agentStatus = agentInfo.currentStatus || "OFFLINE";
                value.agentStatusTooltip = getAgentStatusTooltip(this);
                value.agentName = agentInfo.agentName || '';
                value.nickName = agentInfo.agentNickname || value.agentName || naMessage;
                value.showImage = agentInfo.agentPictureURL ? 'showCustomImage' : 'showDefaultImage';
                value.customImageSrc = agentInfo.agentPictureURL || '';
                value.concurrent = _.isUndefined(agentInfo.openAssignedConversations) ? naMessage : agentInfo.openAssignedConversations;
                value.active = _.isUndefined(agentInfo.activeConversations) ? naMessage : agentInfo.activeConversations;
                value.maxConcurrent = agentInfo.configuredMaxSlots === '-1' ? this.translate('AGENT_LIST_unlimited') : agentInfo.configuredMaxSlots;
                if(lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                    value.agentGroup = value.agentGroupTooltip = agentInfo.agentGroupName || naMessage;
                } else {
                    value.className += " hide_agentGroups";
                }
                value.load = (agentInfo.load || '0') + '%';
                value.onlineRate = _.isNull(agentInfo.onlineRate) ? naMessage : agentInfo.onlineRate + '%';
                value.closedConversations = _.isNull(agentInfo.closedConversations) ? naMessage : agentInfo.closedConversations;

                // Setting the Skills data
                var skills = fetchSkillsDetails(agentInfo.agentSkills || []);
                value.firstSkillName = skills.length === 0 ? this.translate('unassigned') : skills[0].name;
                value.other_skills_hidden = skills.length > 1 ? '' : 'hidden';
                value.otherSkillsNum = skills.length > 1 ? skills.length - 1 : '';
                value.skills = skills.length > 1 ? getSkillsTooltip(skills) : '';

                // Setting the Duration data.
                if(typeof (agentInfo.currentStatusReasonDuration || agentInfo.currentStatusDuration) !== 'undefined') {
                    var duration = lpTag.WebAgent.logicController.getFormatDurationTime(Number(agentInfo.currentStatusReasonDuration || agentInfo.currentStatusDuration), false);
                    value.stateDuration = duration.text;
                    value.stateDurationTooltip = duration.tooltip;
                }
                else { //if no duration - don't show duration at all
                    value.stateDuration = value.stateDurationTooltip = '';
                }
            }

            function fetchSkillsDetails(skills) {
                return skills.map(function(skill){
                    return {
                        id: skill.skillId,
                        name: skill.skillName || naMessage
                    };
                });
            }

            function getSkillsTooltip(skills) {
                var skillsTooltip = '';
                for (var i = 1; i < skills.length; i++) {
                    skillsTooltip += skills[i].name + '<br/>';
                }
                return skillsTooltip;
            }

            function getAgentStatusTooltip(context) {
                var statusTooltip;
                if(agentInfo.currentStatusReason) {
                    statusTooltip = context.agentStatusReasons.getTextById(agentInfo.currentStatusReason);
                } else {
                    statusTooltip = context.translate(agentInfo.currentStatus.toLowerCase());
                }
                return statusTooltip;
            }

            return value;
        }
    };

    window.lpTag = window.lpTag || {};
    lpTag.WebAgent = lpTag.WebAgent || {};

    return MessagingAgentListTableViewController;

});
